import React from "react";
import Link from "gatsby-link";
import { Image } from "@fishrmn/fishrmn-components";

import Logo from "../../data/WholeSol_Logo_no_tag.png";

const NavigationLogo = ({ customStyle = {}, onToggle }) => (
  <div>
    <Link to="/" href="/">
      <div
        className="nav-logo-background"
        style={customStyle}
        onClick={onToggle}
      >
        <Image src={Logo} alt="WholeSol Logo" height="100%" width="100%" />
      </div>
    </Link>
  </div>
);

export default NavigationLogo;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationLogo.jsx